module.exports = __webpack_public_path__ + "img/img-header-mobile.d758ca8.webp";